export class CalendarService {
  constructor() {
    moment.locale('fr');
  }

  private isToday(dayMoment) {
    return dayMoment.isSame(moment(), 'day');
  }

  private isHoliday(dayMoment) {
    const localMoment = moment({
      year: dayMoment.year(),
      month: dayMoment.month(),
      day: dayMoment.date(),
    });
    return localMoment.isFerie();
  }

  getWeek(year, weekOfYear) {
    const week = {
      year: year,
      number: weekOfYear,
      days: {},
    };

    for (let i = 1; i <= 5; i++) {
      const dayMoment = this.getWeekOfYear(year, weekOfYear).day(i);
      week.days[i] = {
        title: dayMoment.format('ddd D MMM'),
        moment: dayMoment,
        isHoliday: this.isHoliday(dayMoment),
        isToday: this.isToday(dayMoment),
      };
    }

    return week;
  }

  getYears() {
    const years: number[] = [];

    const currentYear = new Date().getFullYear();

    for (let i = 2018; i <= currentYear + 1; i++) {
      years.push(i);
    }

    return years;
  }

  getMonths() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }

  /** Retrieve the list month labels */
  getMonthsLabels() {
    return moment.months();
  }

  getWeekOfYear(year, week) {
    const mondayOfYear = moment.utc({ year: year }).day(1);

    //Manage particular case : first week of the year is the week after
    //if first day is friday, saturday or sunday, ie monday.date() <= 28 && monday.date() >= 26
    let weekOfYear;
    if (mondayOfYear.date() <= 28 && mondayOfYear.date() >= 26) {
      //Use add(x, 'weeks') instead of week() function, due to a momentjs bug
      //https://github.com/moment/moment/issues/2496
      weekOfYear = mondayOfYear.add(week, 'weeks');
    } else {
      weekOfYear = mondayOfYear.add(week - 1, 'weeks');
    }

    return weekOfYear;
  }

  isPastMonth(aMoment) {
    const thisMonth = moment().startOf('month');

    return aMoment.isBefore(thisMonth);
  }
}

